<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M5.5 9.25C5.5 9.66422 5.83579 10 6.25 10H10.75C12.4068 10 13.75 8.65683 13.75 7C13.75 5.34314 12.4068 4 10.75 4H6.25C5.83579 4 5.5 4.33579 5.5 4.75V9.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
    <path d="M10.75 10H11.5C13.1568 10 14.5 11.3432 14.5 13C14.5 14.6568 13.1568 16 11.5 16H6.25C5.83579 16 5.5 15.6642 5.5 15.25V10" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'BoldTextIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>